module.exports = __webpack_public_path__ + "img/ma.9c2c17a0.svg";